<template>
    <div>
        <div class="load-box" v-show="isLoad" @click="hide">
            <img class="load" src="@/assets/load.gif" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'loading',
    data () {
      return {
        data: 'true',
        isLoad: true
      }
    },
    methods:{
      hide(){
        this.isLoad = false;
      }
    }
}
</script>
<style>
    .load-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
    }
    .load-box .load{
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10000;
        width: .5rem;
        height: .5rem;
        transform: translate(-50%,-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue